export default {
  'pages.covenantDevice.mac': 'Indirizzo MAC',
  'pages.admin.providerCard.config.grpcAddr': 'Indirizzo gRPC',
  'pages.covenantDevice.cardTitle': 'Gestione Dispositivi Contrattuali',
  'pages.admin.whitelist.mac': 'Indirizzo MAC',
  'pages.covenantDevice.operations': 'Operazioni',
  'pages.covenantDevice.expireTime': 'Data di Scadenza',
  'pages.covenantDevice.updateTime': 'Ora di Aggiornamento',
  'pages.unbindDevice.titleAdmin': 'Scollega Dispositivo (Admin Richiesto)',
  'pages.unbindDevice.inputPlaceholder': 'Inserisci ID dispositivo',
  'pages.unbindDevice.unbind': 'Scollega',
  'pages.unbindDevice.unbinding': 'Scollegamento...',
  'pages.unbindDevice.success': 'Scollegamento riuscito',
  'pages.unbindDevice.fail': 'Scollegamento fallito',
  'pages.layouts.userLayout.title': 'Console di Gestione',
  'pages.login.accountLogin.tab': 'Accesso Account',
  'pages.login.accountLogin.errorMessage':
    'Nome utente/password errati (admin/ant.design)',
  'pages.login.failure': 'Accesso fallito, riprova!',
  'pages.login.success': 'Accesso riuscito!',
  'pages.login.username.placeholder': 'Nome utente: admin o user',
  'pages.login.username.required': 'Inserisci il tuo nome utente!',
  'pages.login.password.placeholder': 'Password: ant.design',
  'pages.login.password.required': 'Inserisci la tua password!',
  'pages.login.phoneLogin.tab': 'Accesso Telefono',
  'pages.login.phoneLogin.errorMessage': 'Errore Codice di Verifica',
  'pages.login.phoneNumber.placeholder': 'Numero di Telefono',
  'pages.login.phoneNumber.required': 'Inserisci il tuo numero di telefono!',
  'pages.login.phoneNumber.invalid': 'Numero di telefono non valido!',
  'pages.login.captcha.placeholder': 'Codice di Verifica',
  'pages.login.captcha.required': 'Inserisci il codice di verifica!',
  'pages.login.phoneLogin.getVerificationCode': 'Ottieni Codice',
  'pages.getCaptchaSecondText': 'sec',
  'pages.login.rememberMe': 'Ricordami',
  'pages.login.forgotPassword': 'Password Dimenticata?',
  'pages.login.submit': 'Accedi',
  'pages.login.loginWith': 'Accedi con:',
  'pages.login.registerAccount': 'Registra Account',
  'pages.welcome.link': 'Benvenuto',
  'pages.welcome.alertMessage':
    'Sono stati rilasciati componenti pesanti più veloci e potenti.',
  'pages.404.subTitle': 'Spiacente, la pagina che hai visitato non esiste.',
  'pages.404.buttonText': 'Torna alla Home',
  'pages.admin.subPage.title': 'Questa pagina può essere visualizzata solo dall\'Admin',
  'pages.admin.subPage.alertMessage':
    'Umi ui è ora rilasciato, benvenuto a usare npm run ui per iniziare l\'esperienza.',
  'pages.searchTable.createForm.newRule': 'Nuova Regola',
  'pages.searchTable.updateForm.ruleConfig': 'Configurazione regola',
  'pages.searchTable.updateForm.basicConfig': 'Informazioni Base',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Nome Regola',
  'pages.searchTable.updateForm.ruleName.nameRules':
    'Inserisci il nome della regola!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Descrizione Regola',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    'Inserisci almeno cinque caratteri',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'Inserisci una descrizione della regola di almeno cinque caratteri!',
  'pages.searchTable.updateForm.ruleProps.title': 'Configura Proprietà',
  'pages.searchTable.updateForm.object': 'Oggetto di Monitoraggio',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Template Regola',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Tipo Regola',
  'pages.searchTable.updateForm.schedulingPeriod.title':
    'Imposta Periodo di Programmazione',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Orario di Inizio',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    'Scegli un orario di inizio!',
  'pages.searchTable.titleDesc': 'Descrizione',
  'pages.searchTable.ruleName': 'Il nome della regola è richiesto',
  'pages.searchTable.titleCallNo': 'Numero di Chiamate del Servizio',
  'pages.searchTable.titleStatus': 'Stato',
  'pages.searchTable.nameStatus.default': 'predefinito',
  'pages.searchTable.nameStatus.running': 'in esecuzione',
  'pages.searchTable.nameStatus.online': 'online',
  'pages.searchTable.nameStatus.abnormal': 'anomalo',
  'pages.searchTable.titleUpdatedAt': 'Ultima Programmazione',
  'pages.searchTable.exception': 'Inserisci il motivo dell\'eccezione!',
  'pages.searchTable.titleOption': 'Opzione',
  'pages.searchTable.config': 'Configurazione',
  'pages.searchTable.subscribeAlert': 'Iscriviti agli avvisi',
  'pages.searchTable.title': 'Modulo di Richiesta',
  'pages.searchTable.new': 'Nuovo',
  'pages.searchTable.chosen': 'scelto',
  'pages.searchTable.item': 'elemento',
  'pages.searchTable.totalServiceCalls': 'Numero Totale di Chiamate del Servizio',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'eliminazione batch',
  'pages.searchTable.batchApproval': 'approvazione batch',
  
  // Agents page related text
  'pages.agents.search.placeholder': 'Cerca agenti',
  'pages.agents.create.button': 'Crea Agente',
  'pages.agents.addDevice.button': 'Aggiungi Dispositivo',
  'pages.agents.create.modal.title': 'Crea Agente',
  'pages.agents.create.modal.nameLabel': 'Nome Agente',
  'pages.agents.create.modal.placeholder': 'Inserisci nome agente',
  'pages.agents.card.id': 'ID',
  'pages.agents.card.voiceModel': 'Modello Vocale',
  'pages.agents.card.languageModel': 'Modello Linguistico',
  'pages.agents.card.lastChat': 'Ultima Chat',
  'pages.agents.card.conversationId': 'ID Conversazione',
  'pages.agents.card.clearConversation': 'Cancella ID Conversazione',
  'pages.agents.card.clearConversation.success': 'ID Conversazione cancellato',
  'pages.agents.card.clearConversation.error': 'Fallimento nel cancellare ID Conversazione',
  'pages.agents.card.configRole': 'Configura Ruolo',
  'pages.agents.card.voiceRecognition': 'Riconoscimento Vocale',
  'pages.agents.card.voiceRecognition.developing': 'Funzionalità in sviluppo, resta sintonizzato',
  'pages.agents.card.historyDialog': 'Dialogo Storico',
  'pages.agents.card.manageDevice': 'Gestisci Dispositivi',
  'pages.agents.card.addDevice': 'Aggiungi Dispositivo',
  'pages.agents.loading': 'Caricamento lista agenti...',
  'pages.agents.reload': 'Ricarica',
  'pages.agents.empty.title': 'Nessun agente disponibile',
  'pages.agents.empty.createFirst': 'Crea il tuo primo agente',
  'pages.agents.delete.title': 'Conferma Eliminazione Agente',
  'pages.agents.delete.content': 'Dopo aver eliminato l\'agente, tutte le configurazioni correlate (inclusi i record di conversazione relativi al dispositivo) non possono essere recuperate. Sei sicuro di voler eliminare?',
  'pages.agents.delete.confirm': 'Conferma Eliminazione',
  'pages.agents.fetch.error': 'Fallimento nel recuperare la lista agenti',
  'pages.agents.network.error': 'Errore di rete, riprova più tardi',
  'pages.agents.speed.patient': 'Paziente',
  'pages.agents.speed.normal': 'Normale',
  'pages.agents.speed.fast': 'Veloce',
  'pages.agents.lastChat.none': 'Nessuna',
  'pages.agents.language.chinese': 'Cinese',
  'pages.agents.loading.tts.error': 'Fallimento nel caricare le voci TTS',
  'pages.agents.loading.llm.error': 'Fallimento nel caricare i fornitori LLM',
  'pages.agents.sort.id': 'Ordina per ID',
  'pages.agents.sort.updatedAt': 'Ordina per ultima modifica',
  'pages.agents.sort.lastConversationAt': 'Ordina per ultima conversazione',
  
  // Register page related text
  'pages.register': 'Registrati',
  'pages.register.title': 'Registrati',
  'pages.register.form.title': 'Registra Nuovo Account',
  'pages.register.submit': 'Registrati',
  'pages.register.username.placeholder': 'Inserisci nome utente',
  'pages.register.username.required': 'Inserisci nome utente!',
  'pages.register.username.min': 'Il nome utente deve essere di almeno 4 caratteri',
  'pages.register.email.placeholder': 'Inserisci email',
  'pages.register.email.required': 'Inserisci email!',
  'pages.register.email.invalid': 'Inserisci un indirizzo email valido!',
  'pages.register.password.placeholder': 'Inserisci password',
  'pages.register.password.required': 'Inserisci password!',
  'pages.register.password.min': 'La password deve essere di almeno 6 caratteri',
  'pages.register.password.pattern': 'La password deve contenere lettere maiuscole, minuscole e numeri',
  'pages.register.confirmPassword.placeholder': 'Conferma password',
  'pages.register.confirmPassword.required': 'Conferma password!',
  'pages.register.confirmPassword.min': 'La password deve essere di almeno 6 caratteri',
  'pages.register.error.passwordMismatch': 'Le due password non corrispondono',
  'pages.register.error.registerFailed': 'Registrazione fallita, riprova!',
  'pages.register.success': 'Registrazione riuscita!',
  
  // Login page related text
  'pages.login.title': 'Console di Gestione Anime AI Chat',
  'pages.login.actionIcons.notImplemented': 'Non ancora implementato, in arrivo presto',
  'pages.login.mobile.captchaError': 'Errore codice di verifica',
  'pages.login.captcha.success': 'Codice di verifica inviato con successo! Codice: 1234',
  'pages.login.forgotPassword.contactAdmin': 'Contatta l\'amministratore',
  'pages.login.mobile.notAvailable': 'Questa funzionalità non è ancora disponibile, usa l\'accesso account',
  
  // AgentSetting page related text
  'pages.agentSetting.title': 'Configura Ruolo',
  'pages.agentSetting.back': 'Indietro',
  'pages.agentSetting.roleTemplate.title': 'Template Ruolo',
  'pages.agentSetting.roleTemplate.label': 'Template',
  'pages.agentSetting.template.taiwanGirlfriend': 'Ragazza Taiwanese',
  'pages.agentSetting.template.potato': 'Patata',
  'pages.agentSetting.template.englishTutor': 'Tutor Inglese',
  'pages.agentSetting.template.curiousBoy': 'Ragazzo Curioso',
  'pages.agentSetting.template.puppyLeader': 'Leader Cucciolo',
  'pages.agentSetting.basicConfig.title': 'Configurazione Base',
  'pages.agentSetting.assistantName.label': 'Nome Assistente',
  'pages.agentSetting.assistantName.placeholder': 'Inserisci nome assistente',
  'pages.agentSetting.assistantName.required': 'Inserisci nome assistente',
  'pages.agentSetting.dialogLanguage.label': 'Lingua Dialogo',
  'pages.agentSetting.dialogLanguage.placeholder': 'Seleziona lingua dialogo',
  'pages.agentSetting.voiceType.label': 'Tipo Voce',
  'pages.agentSetting.voiceType.placeholder': 'Seleziona tipo voce',
  'pages.agentSetting.roleDescription.title': 'Descrizione Ruolo',
  'pages.agentSetting.roleDescription.label': 'Descrizione Ruolo',
  'pages.agentSetting.roleDescription.placeholder': 'Inserisci descrizione ruolo',
  'pages.agentSetting.roleDescription.required': 'Inserisci descrizione ruolo',
  'pages.agentSetting.languageModel.title': 'Modello Linguistico',
  'pages.agentSetting.languageModel.label': 'Modello Linguistico',
  'pages.agentSetting.languageModel.placeholder': 'Seleziona modello linguistico',
  'pages.agentSetting.languageModel.tip': 'Dopo aver cambiato il modello, si raccomanda di cancellare la memoria per evitare di influenzare l\'esperienza di chat.',
  'pages.agentSetting.advancedSettings.expand': 'Espandi Impostazioni Avanzate',
  'pages.agentSetting.advancedSettings.collapse': 'Comprimi Impostazioni Avanzate',
  'pages.agentSetting.recognitionSpeed.label': 'Velocità Riconoscimento Vocale',
  'pages.agentSetting.recognitionSpeed.placeholder': 'Seleziona velocità riconoscimento',
  'pages.agentSetting.speechSpeed.label': 'Velocità Parlato',
  'pages.agentSetting.speechSpeed.placeholder': 'Seleziona velocità parlato',
  'pages.agentSetting.pitchValue.label': 'Volume personaggio',
  'pages.agentSetting.button.reset': 'Reimposta',
  'pages.agentSetting.button.save': 'Salva',
  'pages.agentSetting.save.success': 'Salvataggio riuscito',
  'pages.agentSetting.save.error': 'Salvataggio fallito',
  'pages.agentSetting.save.missingId': 'ID agente mancante, impossibile salvare',
  'pages.agentSetting.load.tts.error': 'Fallimento nel caricare le voci TTS',
  'pages.agentSetting.speed.slow': 'Lento',
  'pages.agentSetting.speed.normal': 'Normale',
  'pages.agentSetting.speed.fast': 'Veloce',
  'pages.agentSetting.speed.patient': 'Paziente',
  'pages.agentSetting.language.chinese': 'Cinese',
  'pages.agentSetting.language.english': 'Inglese',
  'pages.agentSetting.language.spanish': 'Spagnolo',
  'pages.agentSetting.language.french': 'Francese',
  'pages.agentSetting.language.german': 'Tedesco',
  'pages.agentSetting.language.japanese': 'Giapponese',
  'pages.agentSetting.language.korean': 'Coreano',
  'pages.agentSetting.language.portuguese': 'Portoghese',
  'pages.agentSetting.language.arabic': 'Arabo',
  'pages.agentSetting.language.russian': 'Russo',
  'pages.agentSetting.language.italian': 'Italiano',
  'pages.agentSetting.language.turkish': 'Turco',
  'pages.agentSetting.language.polish': 'Polacco',
  'pages.agentSetting.language.catalan': 'Catalano',

  // DeviceManagement page related text
  'pages.devices.title': 'Gestisci Dispositivi',
  'pages.devices.breadcrumb.agents': 'Agenti',
  'pages.devices.breadcrumb.devices': 'Gestisci Dispositivi',
  'pages.devices.button.addDevice': 'Aggiungi Dispositivo',
  'pages.devices.warning.noAgentId': 'Nessun agentId specificato, impossibile ottenere la lista dispositivi',
  'pages.devices.device.unnamed': 'Dispositivo Senza Nome',
  'pages.devices.device.macAddress': 'Indirizzo Mac',
  'pages.devices.device.lastActive': 'Ultima Attività',
  'pages.devices.device.firmwareVersion': 'Versione Firmware',
  'pages.devices.device.otaUpgrade': 'Aggiornamento OTA',
  'pages.devices.device.noData': 'Nessun Dato',
  'pages.devices.copy.success': 'Indirizzo MAC copiato',
  'pages.devices.unbind.title': 'Conferma Scollegamento Dispositivo',
  'pages.devices.unbind.content': 'Lo scollegamento del dispositivo non può essere recuperato. Se hai bisogno di usarlo di nuovo, devi ricollegarlo. Sei sicuro di scollegare?',
  'pages.devices.unbind.confirm': 'Conferma Scollegamento',
  'pages.devices.unbind.cancel': 'Annulla',
  'pages.devices.unbind.success': 'Dispositivo scollegato',
  'pages.devices.unbind.error': 'Scollegamento fallito',
  'pages.devices.ota.enabled': 'Aggiornamento OTA abilitato',
  'pages.devices.ota.disabled': 'Aggiornamento OTA disabilitato',
  
  // HistoryDialogs page related text
  'pages.historyDialogs.title': 'Dialoghi Storici',
  'pages.historyDialogs.breadcrumb.agents': 'Agenti',
  'pages.historyDialogs.breadcrumb.historyDialogs': 'Dialoghi Storici',
  'pages.historyDialogs.empty.title': 'Nessuna conversazione selezionata',
  'pages.historyDialogs.empty.description': 'Seleziona una conversazione',
  'pages.historyDialogs.agent': 'Agente',
  'pages.historyDialogs.agent.id': 'id',
  'pages.historyDialogs.conversationDetail': 'Dettagli Conversazione',
  'pages.historyDialogs.selectConversation': 'Seleziona una conversazione',
  'pages.historyDialogs.delete.title': 'Elimina Conversazione',
  'pages.historyDialogs.delete.content': 'La conversazione non può essere recuperata dopo l\'eliminazione. Conferma l\'operazione.',
  'pages.historyDialogs.delete.confirm': 'Conferma',
  'pages.historyDialogs.delete.cancel': 'Annulla',
  'pages.historyDialogs.message.delete.confirm': 'Sei sicuro di voler eliminare questo messaggio? Non può essere recuperato dopo l\'eliminazione.',
  'pages.historyDialogs.detail.title': 'Dettagli Conversazione',
  'pages.historyDialogs.agent.label': 'Agente:',
  'pages.historyDialogs.user.label': 'Utente:',
  'pages.historyDialogs.loading': 'Caricamento...',
  'pages.historyDialogs.error.loadFailed': 'Fallimento nel caricare la lista conversazioni',
  'pages.historyDialogs.error.deleteFailed': 'Fallimento nell\'eliminare conversazione',
  'pages.historyDialogs.success.deleteSuccess': 'Conversazione eliminata con successo',
  
  // MessageList page related text
  'pages.messageList.empty': 'Nessun messaggio',
  'pages.messageList.user': 'Utente',
  'pages.messageList.ai': 'IA',
  
  // Settings page related text
  'pages.settings.basicInfo.title': 'Informazioni Base',
  'pages.settings.avatar.label': 'Avatar:',
  'pages.settings.avatar.change': 'Cambia Avatar',
  'pages.settings.avatar.updateSuccess': 'Avatar aggiornato con successo',
  'pages.settings.avatar.updateFailed': 'Fallimento nell\'aggiornare avatar',
  'pages.settings.username.label': 'Nome Utente:',
  'pages.settings.nickname.label': 'Nickname:',
  'pages.settings.nickname.change': 'Modifica Nickname',
  'pages.settings.nickname.modal.title': 'Modifica Nickname',
  'pages.settings.nickname.form.label': 'Nuovo Nickname',
  'pages.settings.nickname.form.required': 'Inserisci nuovo nickname',
  'pages.settings.nickname.form.length': 'La lunghezza del nickname dovrebbe essere 2-20 caratteri',
  'pages.settings.nickname.updateSuccess': 'Nickname aggiornato con successo',
  'pages.settings.nickname.updateFailed': 'Fallimento nell\'aggiornare nickname',
  'pages.settings.registerTime.label': 'Orario Registrazione:',
  'pages.settings.email.label': 'Email:',
  'pages.settings.email.unbind': 'Non collegato',
  'pages.settings.email.bind': 'Collega Email',
  'pages.settings.email.change': 'Cambia Email',
  'pages.settings.email.modal.title': 'Collega Email',
  'pages.settings.email.modal.changeTitle': 'Cambia Email',
  'pages.settings.email.form.label': 'Email',
  'pages.settings.email.form.required': 'Inserisci email',
  'pages.settings.email.form.invalid': 'Formato email non valido',
  'pages.settings.email.bindSuccess': 'Email collegata con successo',
  'pages.settings.email.bindFailed': 'Fallimento nel collegare email',
  'pages.settings.changePassword.title': 'Cambia Password',
  'pages.settings.changePassword.button': 'Cambia Password',
  'pages.settings.changePassword.modal.title': 'Cambia Password',
  'pages.settings.changePassword.oldPassword.label': 'Vecchia Password',
  'pages.settings.changePassword.oldPassword.required': 'Inserisci vecchia password',
  'pages.settings.changePassword.newPassword.label': 'Nuova Password',
  'pages.settings.changePassword.newPassword.required': 'Inserisci nuova password',
  'pages.settings.changePassword.newPassword.min': 'La nuova password deve essere di almeno 6 caratteri',
  'pages.settings.changePassword.confirmPassword.label': 'Conferma Nuova Password',
  'pages.settings.changePassword.confirmPassword.required': 'Conferma nuova password',
  'pages.settings.changePassword.confirmPassword.mismatch': 'Le password non corrispondono',
  'pages.settings.changePassword.success': 'Password cambiata con successo',
  'pages.settings.changePassword.failed': 'Fallimento nel cambiare password',
  'pages.settings.deleteAccount.title': 'Elimina Account',
  'pages.settings.deleteAccount.button': 'Elimina Account',
  'pages.settings.deleteAccount.confirm.title': 'Conferma Eliminazione Account?',
  'pages.settings.deleteAccount.confirm.content': 'Questa operazione non può essere annullata. Sei sicuro di voler eliminare il tuo account?',
  'pages.settings.deleteAccount.confirm.ok': 'Elimina',
  'pages.settings.deleteAccount.confirm.cancel': 'Annulla',
  'pages.settings.deleteAccount.success': 'Account eliminato con successo',
  'pages.settings.deleteAccount.failed': 'Fallimento nell\'eliminare account',
  'pages.settings.profile.fetchFailed': 'Fallimento nel recuperare informazioni utente',
  'pages.settings.form.submit': 'Invia',
  'pages.settings.password.title': 'Impostazioni Password',
  'pages.settings.basicInfo.username': 'Nome Utente',
  'pages.settings.basicInfo.nickname': 'Nickname',
  'pages.settings.basicInfo.avatar': 'Avatar',
  'pages.settings.basicInfo.editNickname': 'Modifica Nickname',
  'pages.settings.basicInfo.editNicknameTitle': 'Modifica Nickname',
  'pages.settings.basicInfo.newNicknameLabel': 'Nuovo Nickname',
  'pages.settings.basicInfo.nicknameChangeSuccess': 'Nickname cambiato con successo',
  'pages.settings.basicInfo.openId': 'OpenID:',
  'pages.settings.submit': 'Invia',
  'pages.settings.deleteAccount.confirmTitle': 'Conferma Eliminazione Account',
  'pages.settings.deleteAccount.confirmContent': 'Dopo aver eliminato il tuo account, tutti i tuoi dati saranno permanentemente eliminati e non possono essere recuperati, e non potrai più accedere con questo account. Procedi con cautela!',
  'pages.settings.deleteAccount.cancel': 'Annulla',
  'pages.settings.deleteAccount.confirm': 'Conferma Eliminazione',
  
  // Admin Dashboard
  'pages.admin.dashboard.userCount': 'Numero Utenti',
  'pages.admin.dashboard.deviceCount': 'Numero Dispositivi', 
  'pages.admin.dashboard.agentCount': 'Numero Agenti',
  'pages.admin.dashboard.onlineUsers': 'Utenti Online',
  'pages.admin.dashboard.sessionDevices': 'Dispositivi di Sessione',
  'pages.admin.dashboard.memoryUsage': 'Uso Memoria',
  'pages.admin.dashboard.cpuUsage': 'Uso CPU',
  'pages.admin.dashboard.fetchError': 'Fallimento nel recuperare dati',
  'pages.admin.dashboard.networkError': 'Errore di Rete',

  // Admin User Management
  'pages.admin.user.id': 'ID',
  'pages.admin.user.username': 'Nome Utente',
  'pages.admin.user.email': 'Email',
  'pages.admin.user.status': 'Stato',
  'pages.admin.user.status.all': 'Tutti',
  'pages.admin.user.status.disabled': 'Disabilitato',
  'pages.admin.user.status.normal': 'Normale',
  'pages.admin.user.quotaUsed': 'Quota Giornaliera Utilizzata',
  'pages.admin.user.quotaTotal': 'Quota Giornaliera Totale',
  'pages.admin.user.createdAt': 'Creato il',
  'pages.admin.user.operations': 'Operazioni',
  'pages.admin.user.edit': 'Modifica',
  'pages.admin.user.detail': 'Dettaglio',
  'pages.admin.user.editModal.title': 'Modifica Utente',
  'pages.admin.user.status.label': 'Stato Utente',
  'pages.admin.user.status.enable': 'Abilita',
  'pages.admin.user.status.disable': 'Disabilita',
  'pages.admin.user.quotaUsed.label': 'Quota Giornaliera Utilizzata',
  'pages.admin.user.quotaTotal.label': 'Quota Giornaliera Totale',
  'pages.admin.user.email.label': 'Email',
  'pages.admin.user.save.success': 'Salvataggio riuscito',
  'pages.admin.user.save.failed': 'Salvataggio fallito',
  'pages.admin.user.list.title': 'Lista Utenti',

  // Admin Model Providers
  'pages.admin.providers.title': 'Gestione Fornitori di Modelli',
  'pages.admin.providers.total': 'Totale {total} fornitori',
  'pages.admin.providers.stats': 'ASR: {asr}, TTS: {tts}, LLM: {llm}, VLLLM: {vlllm}',
  'pages.admin.providers.addNew': 'Aggiungi Nuovo Fornitore',
  'pages.admin.providers.search.placeholder': 'Cerca nome fornitore, endpoint o modello...',
  'pages.admin.providers.filter.all': 'Tutti i Tipi',
  'pages.admin.providers.filter.asr': 'ASR - Riconoscimento Vocale',
  'pages.admin.providers.filter.tts': 'TTS - Sintesi Vocale', 
  'pages.admin.providers.filter.llm': 'LLM - Modello Linguistico Grande',
  'pages.admin.providers.filter.vlllm': 'VLLLM - Modello Linguistico di Visione',
  'pages.admin.providers.empty.noProviders': 'Nessun fornitore ancora',
  'pages.admin.providers.empty.noMatches': 'Nessun fornitore corrispondente trovato',
  'pages.admin.providers.empty.addFirst': 'Clicca il pulsante sopra per aggiungere il tuo primo fornitore di modello',
  'pages.admin.providers.empty.adjustFilters': 'Prova ad aggiustare i criteri di ricerca o i filtri',
  'pages.admin.providers.type.asr': 'ASR - Riconoscimento Vocale',
  'pages.admin.providers.type.tts': 'TTS - Sintesi Vocale',
  'pages.admin.providers.type.llm': 'LLM - Modello Linguistico Grande',
  'pages.admin.providers.type.vlllm': 'VLLLM - Modello Linguistico di Visione',
  'pages.admin.providers.success.created': 'Fornitore aggiunto con successo!',
  'pages.admin.providers.success.updated': 'Fornitore aggiornato con successo!',
  'pages.admin.providers.success.deleted': 'Fornitore eliminato con successo!',
  'pages.admin.providers.success.statusToggled': 'Stato cambiato con successo!',
  'pages.admin.providers.error.createFailed': 'Fallimento nell\'aggiungere fornitore, riprova',
  'pages.admin.providers.error.updateFailed': 'Fallimento nell\'aggiornare fornitore, riprova',
  'pages.admin.providers.error.deleteFailed': 'Fallimento nell\'eliminare fornitore, riprova',
  'pages.admin.providers.error.testFailed': 'Test di connessione fallito, controlla rete o configurazione',
  'pages.admin.providers.error.toggleFailed': 'Fallimento nel cambiare stato, riprova',
  'pages.admin.providers.error.loadFailed': 'Fallimento nel caricare lista fornitori, aggiorna la pagina',

  // Admin Settings
  'pages.admin.settings.title': 'Impostazioni di Sistema',
  'pages.admin.settings.asr.label': 'Servizio ASR',
  'pages.admin.settings.asr.placeholder': 'Seleziona Servizio ASR',
  'pages.admin.settings.tts.label': 'Servizio TTS',
  'pages.admin.settings.tts.placeholder': 'Seleziona Servizio TTS',
  'pages.admin.settings.llm.label': 'Servizio LLM',
  'pages.admin.settings.llm.placeholder': 'Seleziona Servizio LLM',
  'pages.admin.settings.vlllm.label': 'Servizio VLLLM',
  'pages.admin.settings.vlllm.placeholder': 'Seleziona Servizio VLLLM',
  'pages.admin.settings.prompt.label': 'Impostazioni Prompt',
  'pages.admin.settings.prompt.placeholder': 'Inserisci prompt di sistema...',
  'pages.admin.settings.quickReply.label': 'Parole Risposta Rapida',
  'pages.admin.settings.quickReply.placeholder': 'Inserisci nuova parola risposta rapida',
  'pages.admin.settings.quickReply.add': 'Aggiungi',
  'pages.admin.settings.deleteAudio.label': 'Elimina Audio',
  'pages.admin.settings.deleteAudio.enabled': 'Abilitato',
  'pages.admin.settings.deleteAudio.disabled': 'Disabilitato',
  'pages.admin.settings.usePrivateConfig': 'Usa Configurazione Privata',
  'pages.admin.settings.save': 'Salva Configurazione',
  'pages.admin.settings.saving': 'Salvando...',
  'pages.admin.settings.reset': 'Reimposta',
  'pages.admin.settings.success.saved': 'Configurazione salvata con successo!',
  'pages.admin.settings.error.saveFailed': 'Fallimento nel salvare configurazione, riprova',
  'pages.admin.settings.error.loadFailed': 'Fallimento nel caricare configurazione, aggiorna la pagina e riprova',


  // Add Device Dialog
  'pages.addDevice.modal.title': 'Aggiungi Dispositivo',
  'pages.addDevice.verificationCode.label': 'Codice di Verifica:',
  'pages.addDevice.verificationCode.placeholder': 'Inserisci il codice di verifica a 6 cifre dal dispositivo',
  'pages.addDevice.verificationCode.required': 'Inserisci un codice di verifica a 6 cifre',
  'pages.addDevice.verificationCode.error': 'Inserisci un codice di verifica a 6 cifre',

  // Provider Modal
  'pages.admin.providerModal.edit.title': 'Modifica Fornitore',
  'pages.admin.providerModal.add.title': 'Aggiungi Nuovo Fornitore',
  'pages.admin.providerModal.name.label': 'Nome Fornitore *',
  'pages.admin.providerModal.name.placeholder': 'es.: OpenAI, Doubao TTS',
  'pages.admin.providerModal.name.required': 'Inserisci nome fornitore',
  'pages.admin.providerModal.type.label': 'Categoria Servizio *',
  'pages.admin.providerModal.subType.label': 'Tipo Specifico *',
  'pages.admin.providerModal.subType.required': 'Seleziona tipo specifico',
  'pages.admin.providerModal.config.title': 'Configurazione',
  'pages.admin.providerModal.api.url.label': 'URL API *',
  'pages.admin.providerModal.api.url.required': 'Inserisci URL API',
  'pages.admin.providerModal.model.name.label': 'Nome Modello *',
  'pages.admin.providerModal.model.name.required': 'Inserisci nome modello',
  'pages.admin.providerModal.api.key.label': 'Chiave API *',
  'pages.admin.providerModal.api.key.required': 'Inserisci chiave API',
  'pages.admin.providerModal.temperature.label': 'Temperatura (0-2)',
  'pages.admin.providerModal.temperature.error': 'La temperatura dovrebbe essere tra 0-2',
  'pages.admin.providerModal.maxTokens.label': 'Token Max',
  'pages.admin.providerModal.maxTokens.error': 'I token max dovrebbero essere tra 1-32768',
  'pages.admin.providerModal.topP.label': 'Top-P',
  'pages.admin.providerModal.appid.label': 'ID App *',
  'pages.admin.providerModal.appid.required': 'Inserisci ID App',
  'pages.admin.providerModal.accessToken.label': 'Token di Accesso *',
  'pages.admin.providerModal.accessToken.required': 'Inserisci token di accesso',
  'pages.admin.providerModal.cluster.label': 'Cluster',
  'pages.admin.providerModal.grpc.host.label': 'Host gRPC *',
  'pages.admin.providerModal.grpc.host.required': 'Inserisci indirizzo host gRPC',
  'pages.admin.providerModal.grpc.port.label': 'Porta gRPC *',
  'pages.admin.providerModal.grpc.port.required': 'Inserisci porta gRPC',
  'pages.admin.providerModal.voice.label': 'Voce *',
  'pages.admin.providerModal.voice.required': 'Inserisci tipo voce',
  'pages.admin.providerModal.token.label': 'Token *',
  'pages.admin.providerModal.token.required': 'Inserisci token',
  'pages.admin.providerModal.websocket.label': 'URL WebSocket *',
  'pages.admin.providerModal.websocket.required': 'Inserisci URL WebSocket',
  'pages.admin.providerModal.siliconflow.apiKey.label': 'Chiave API *',
  'pages.admin.providerModal.siliconflow.apiKey.required': 'Inserisci chiave API',
  'pages.admin.providerModal.siliconflow.baseUrl.label': 'URL API',
  'pages.admin.providerModal.manage.voices': 'Gestisci Voci',
  'pages.admin.providerModal.edge.noConfig': 'Microsoft Edge TTS non richiede configurazione aggiuntiva',
  'pages.admin.providerModal.submit.error': 'Invio fallito, riprova',

  // Provider Card
  'pages.admin.providerCard.status.active': 'Attivo',
  'pages.admin.providerCard.status.inactive': 'Offline',
  'pages.admin.providerCard.status.error': 'Errore',
  'pages.admin.providerCard.status.unknown': 'Sconosciuto',
  'pages.admin.providerCard.warning.readonly.test': 'Permesso sola lettura, impossibile testare fornitore',
  'pages.admin.providerCard.warning.readonly.delete': 'Permesso sola lettura, impossibile eliminare fornitore',
  'pages.admin.providerCard.warning.readonly.edit': 'Permesso sola lettura, impossibile modificare fornitore',
  'pages.admin.providerCard.warning.readonly.toggle': 'Permesso sola lettura, impossibile cambiare stato',
  'pages.admin.providerCard.button.disable': 'Disabilita',
  'pages.admin.providerCard.button.enable': 'Abilita',
  'pages.admin.providerCard.button.testing': 'Testando...',
  'pages.admin.providerCard.button.test': 'Testa',
  'pages.admin.providerCard.button.edit': 'Modifica',
  'pages.admin.providerCard.button.delete': 'Elimina',
  'pages.admin.providerCard.delete.title': 'Sei sicuro di voler eliminare questo elemento?',
  'pages.admin.providerCard.delete.content': 'Non può essere recuperato dopo l\'eliminazione, conferma l\'operazione.',
  'pages.admin.providerCard.config.type': 'Tipo',
  'pages.admin.providerCard.config.apiUrl': 'URL API',
  'pages.admin.providerCard.config.model': 'Modello',
  'pages.admin.providerCard.config.apiKey': 'Chiave API',
  'pages.admin.providerCard.config.temperature': 'Temperatura',
  'pages.admin.providerCard.config.maxTokens': 'Token Max',
  'pages.admin.providerCard.config.appid': 'ID App',
  'pages.admin.providerCard.config.cluster': 'Cluster',
  'pages.admin.providerCard.config.accessToken': 'Token di Accesso',
  'pages.admin.providerCard.config.grpcHost': 'Host gRPC',
  'pages.admin.providerCard.config.grpcPort': 'Porta gRPC',
  'pages.admin.providerCard.config.voice': 'Voce',
  'pages.admin.providerCard.config.format': 'Formato',
  'pages.admin.providerCard.config.token': 'Token',
  'pages.admin.providerCard.config.outputDir': 'Directory di Output',
  'pages.admin.providerCard.voices.supported': 'Voci Supportate',
  'pages.admin.providerCard.voices.count': '',
  'pages.admin.providerCard.test.failed': 'Test fallito',

    // OpsManage
  'pages.admin.ops.service.title': 'Gestione Servizi',
  'pages.admin.ops.upload.button': 'Carica File Servizio',
  'pages.admin.ops.upload.success': 'File servizio caricato con successo',
  'pages.admin.ops.upload.error': 'Caricamento file servizio fallito',
  'pages.admin.ops.restart.button': 'Riavvia Servizio',
  'pages.admin.ops.restart.confirmTitle': 'Attenzione: Sei sicuro di voler riavviare il servizio?',
  'pages.admin.ops.restart.desc': 'Riavviare il servizio disconnetterà tutte le connessioni correnti e renderà il servizio temporaneamente non disponibile.',
  'pages.admin.ops.restart.warn': 'Questa operazione fermerà solo il processo di servizio corrente. Assicurati che un daemon o script di auto-riavvio sia configurato sul server, altrimenti il servizio non si riprenderà automaticamente!',
  'pages.admin.ops.restart.ok': 'Conferma Riavvio',
  'pages.admin.ops.restart.cancel': 'Annulla',
  'pages.admin.ops.restart.success': 'Comando riavvio servizio inviato',
  'pages.admin.ops.restart.error': 'Riavvio servizio fallito',
  'pages.admin.ops.log.title': 'Visualizzazione e Download Log',
  'pages.admin.ops.web.upload.button': 'Carica web.zip',
  'pages.admin.ops.web.upload.success': 'web.zip caricato con successo',
  'pages.admin.ops.web.upload.error': 'Caricamento web.zip fallito',
  'pages.admin.ops.web.upload.onlyzip': 'Solo file zip sono consentiti',
  'pages.admin.ops.web.update.button': 'Aggiorna directory web',
  'pages.admin.ops.web.update.success': 'Comando aggiornamento directory web inviato',
  'pages.admin.ops.web.update.error': 'Aggiornamento directory web fallito',
  'pages.admin.ops.web.upload.onlywebzip': 'Solo un file chiamato web.zip è consentito',

  // Recorder Management
  'pages.admin.recorder.title': 'Gestione Registratore Dispositivo',
  'pages.admin.recorder.inputDeviceId': 'Inserisci ID dispositivo',
  'pages.admin.recorder.inputPlaceholder': 'Inserisci ID dispositivo',
  'pages.admin.recorder.search': 'Cerca',
  'pages.admin.recorder.list.title': 'Lista Registratori',
  'pages.admin.recorder.fetchSuccess': 'Record registratore recuperati con successo',
  'pages.admin.recorder.fetchError': 'Fallimento nel recuperare lista registratori',
  'pages.admin.recorder.empty': 'Nessun dato registratore, inserisci ID dispositivo per cercare',
  'pages.admin.recorder.totalCount': 'Statistiche',
  'pages.admin.recorder.conversationId': 'ID Conversazione',

  'pages.agentSetting.mcp.modal.title': 'Impostazioni Endpoint MCP',
  'pages.agentSetting.mcp.modal.statusLabel': 'Stato Endpoint',
  'pages.agentSetting.mcp.modal.online': 'Online',
  'pages.agentSetting.mcp.modal.disconnected': 'Disconnesso',
  'pages.agentSetting.mcp.modal.unknown': 'Sconosciuto',
  'pages.agentSetting.mcp.modal.refresh': 'Aggiorna',
  'pages.agentSetting.mcp.modal.enabledServices': 'Servizi Abilitati',
  'pages.agentSetting.mcp.modal.endpointLabel': 'Indirizzo Endpoint',
  'pages.agentSetting.mcp.modal.endpointDesc': 'Di seguito è riportato lindirizzo endpoint MCP dellagente.',
  'pages.agentSetting.mcp.modal.docLink': 'Visualizza Documentazione Endpoint',
  'pages.agentSetting.mcp.modal.noEndpoint': 'Nessun Endpoint Disponibile',
  'pages.agentSetting.mcp.modal.hide': 'Nascondi',
  'pages.agentSetting.mcp.title': 'Impostazioni MCP', 
  'pages.agentSetting.mcp.customService': 'Servizio Personalizzato',
  'pages.agentSetting.mcp.officialServices': 'Servizi Ufficiali',
  'pages.agentSetting.mcp.officialServices.placeholder': 'Seleziona Servizi Ufficiali',
  'pages.agentSetting.mcp.services.weather': 'Meteo',
  'pages.agentSetting.mcp.services.joke': 'Barzelletta',
  'pages.agentSetting.mcp.services.music': 'Musica',
  'pages.agentSetting.mcp.services.news': 'Notizie',
  'pages.agentSetting.mcp.error.missingId': 'Mancante ID Agente, impossibile recuperare endpoint',
  'pages.agentSetting.mcp.error.noEndpoint': 'Impossibile recuperare endpoint dal server',
'pages.agentSetting.mcp.error.fetchFailed': 'Recupero endpoint fallito',
  'pages.agentSetting.mcp.button.getEndpoint': 'Ottieni Endpoint MCP',

  // Memory settings
  'pages.agentSetting.memory.title': 'Memoria a breve termine',
  'pages.agentSetting.memory.type.label': 'Tipo di memoria',
  'pages.agentSetting.memory.type.none': 'Senza memoria',
  'pages.agentSetting.memory.type.shortTerm': 'Memoria a breve termine',
  'pages.agentSetting.memory.current.label.short': 'Memoria attuale',
  'pages.agentSetting.memory.current.help': 'Rigenerata dopo ogni conversazione',
  'pages.agentSetting.memory.clear': 'Cancella memoria',
  'pages.agentSetting.memory.clear.tip': 'Memoria contrassegnata per la cancellazione, clicca su salva per applicare',
  'pages.agentSetting.memory.content.label': 'Contenuto della memoria',
  'pages.agentSetting.memory.content.placeholder': 'Recupera il contenuto più recente della memoria a breve termine dell\'agente',
  'pages.agentSetting.memory.content.editPlaceholder': 'Per favore inserisci il contenuto della memoria',
  'pages.agentSetting.memory.edit': 'Modifica memoria',
  'pages.agentSetting.memory.edit.success': 'Memoria aggiornata, per favore salva per applicare',
  'pages.agentSetting.memory.edit.save': 'Salva modifiche',
  'pages.agentSetting.memory.edit.cancel': 'Annulla',

  // Pulsanti e operazioni comuni
  'pages.common.cancel': 'Annulla',

  // Configurazione di sistema
  'pages.admin.systemConfig.roleName': 'Nome Ruolo',
  'pages.admin.systemConfig.roleDesc': 'Descrizione Ruolo',
  'pages.admin.systemConfig.enabled': 'Stato Abilitato',
  'pages.admin.systemConfig.featureName': 'Nome Funzionalità',
  'pages.admin.systemConfig.featureDesc': 'Descrizione Funzionalità',
  'pages.admin.systemConfig.exitCommand': 'Comando di Uscita',
  'pages.admin.systemConfig.mcpName': 'Nome MCP',
  'pages.admin.systemConfig.newNameOptional': 'Nuovo Nome (Opzionale)',
  'pages.admin.systemConfig.configJson': 'Config JSON',
  'pages.admin.systemConfig.useDeviceCode': 'Usa Codice Dispositivo',
  'pages.admin.systemConfig.quickReply': 'Risposta Rapida',
  'pages.admin.systemConfig.shortTermMemory': 'Memoria a Breve Termine',
  'pages.admin.systemConfig.saveUserAudio': 'Salva File Audio Utente',
  'pages.admin.systemConfig.enableWhiteList': 'Abilita Whitelist',
  'pages.admin.systemConfig.speakerDetect': 'Riconoscimento Vocale',
  'pages.admin.systemConfig.recorderManagerEnable': 'Abilita Gestione Registratore',
  'pages.admin.systemConfig.voiceCloneEnable': 'Abilita Clonazione Vocale',
  'pages.admin.systemConfig.flattenedChatHistory': 'Cronologia Chat Appiattita',
  'pages.admin.systemConfig.dialogueHistoryLength': 'Lunghezza Cronologia Dialogo',
  'pages.admin.systemConfig.userTotalQuota': 'Quota Totale Utente',
  'pages.admin.systemConfig.dailyClearQuota': 'Quota Giornaliera',
  'pages.admin.systemConfig.checkDeviceModeImmediately': 'Controlla Modalità Dispositivo Immediatamente',
  'pages.admin.systemConfig.defaultObserverUserOnRegister': 'Ruolo Osservatore Predefinito per Nuovi Utenti',
  'pages.admin.systemConfig.status': 'Stato',
  'pages.admin.systemConfig.port': 'Porta',
  'pages.admin.systemConfig.udpShowPort': 'Mostra Porta',
  'pages.admin.systemConfig.accessToken': 'Token di Accesso',
  'pages.admin.systemConfig.activateText': 'Testo di Attivazione',
  'pages.admin.systemConfig.logLevel': 'Livello Log',
  'pages.admin.systemConfig.logDir': 'Directory Log',
  'pages.admin.systemConfig.logFileName': 'Nome File Log',

  // Clonazione Vocale
  'pages.console.voiceClone.name': 'Nome',
  'pages.console.voiceClone.provider': 'Fornitore',
  'pages.console.voiceClone.mode': 'Modalità',
  'pages.console.voiceClone.record': 'Registra',
  'pages.console.voiceClone.upload': 'Carica',

  // Riconoscimento Vocale
  'pages.console.speakers.name': 'Nome',
  'pages.console.speakers.mode': 'Modalità',
  'pages.console.speakers.record': 'Registra',
  'pages.console.speakers.upload': 'Carica',

  // Configurazione Pagina
  'pages.console.settings.email': 'Email',
  'pages.console.settings.oldPassword': 'Vecchia Password',
  'pages.console.settings.newPassword': 'Nuova Password',
  'pages.console.settings.confirmNewPassword': 'Conferma Nuova Password',

  // Fornitore VLLM
  'pages.providers.vllm.maxPixels': 'Massimi Pixel',
  'pages.admin.providerModal.copyAsNew': 'Copia come Nuovo Fornitore',

  'pages.unbindDevice.cardTitle': 'Dissociazione dispositivo',
  'pages.whiteList.cardTitle': 'Gestione lista bianca',
  'pages.admin.ops.logViewer.previewTitle': 'Anteprima registro',
  'pages.admin.ops.logViewer.fileName': 'Nome file:',
  'pages.admin.ops.logViewer.lineCount': 'Numero righe:',
  'pages.admin.ops.logViewer.previewBtn': 'Anteprima',
  'pages.admin.ops.logViewer.noContent': 'Nessun contenuto',
  'pages.admin.devices': 'Gestione dispositivi',
  'pages.admin.unbindDevice': 'Dissociazione dispositivo',
  'pages.admin.deviceManage': 'Gestione dispositivi',
  'pages.systemConfig.quickReply': 'Risposta rapida',
  'pages.systemConfig.useShortTermMemory': 'Memoria a breve termine',
  'pages.systemConfig.useShortTermMemory.desc': 'Quando attivato, il sistema utilizza un meccanismo di memoria a breve termine e la aggiorna dopo ogni round di dialogo. Quando disattivato, la memoria a breve termine non viene utilizzata.',
  'pages.agentSetting.mcp.modal.show': 'Mostra',
  'pages.agentSetting.mcp.modal.copied': 'Copiato',
  'pages.agentSetting.mcp.modal.copy': 'Copia',
  'pages.admin.providerModal.model.label': 'Modello *',
  'pages.admin.providerModal.model.placeholder': 'Inserisci il nome del modello',
  'pages.admin.providerModal.model.required': 'Inserisci il nome del modello',
  'pages.admin.providerModal.security.title': 'Impostazioni di sicurezza',
  'pages.admin.providerModal.appid.placeholder': 'ID app Doubao',
  'pages.admin.providerModal.accessToken.placeholder': 'Token di accesso',
  'pages.admin.providerModal.grpc.addr.label': 'Indirizzo gRPC (Host:Porta) *',
  'pages.admin.providerModal.grpc.addr.required': 'Inserisci l\'indirizzo gRPC (Host:Porta)',
  'pages.admin.providerModal.token.placeholder': 'Token Doubao',
  'pages.admin.providerModal.siliconflow.apiKey.placeholder': 'Chiave API',
  'pages.admin.providerModal.manageVoices': 'Gestisci voci',
  'pages.admin.whiteList.inputMac': 'Inserisci l\'indirizzo MAC',
  'pages.admin.whiteList.batchAdd': 'Aggiungi in batch',
  'pages.admin.whiteList.add': 'Aggiungi',
  'pages.admin.whiteList.list.title': 'Lista indirizzi MAC',
  'pages.admin.whiteList.selectCsvTip': 'Seleziona un file CSV',
  'pages.admin.whiteList.uploadSuccess': 'Caricamento riuscito',
  'pages.admin.whiteList.uploadFailed': 'Caricamento fallito',
  'pages.admin.whiteList.invalidMac': 'Inserisci un indirizzo MAC valido',
  'pages.admin.settings.voiceCloneEnable': 'Attiva clonazione vocale',
  'pages.agentSetting.roleTemplate.empty': 'Nessun modello disponibile. Controlla role_template.json',
  'pages.admin.providerModal.save': 'Salva',
  'pages.contractDevice.cardTitle': 'Gestione dispositivi contrattuali',
  'pages.contractDevice.mac': 'Indirizzo MAC',
  'pages.contractDevice.protocolType': 'Tipo di protocollo',
  'pages.contractDevice.status': 'Stato',
  'pages.contractDevice.expireTime': 'Data di scadenza',
  'pages.contractDevice.updateTime': 'Ora di aggiornamento',
  'pages.contractDevice.operations': 'Operazioni',
  'pages.contractDevice.edit': 'Modifica',
  'pages.contractDevice.delete': 'Elimina',
  'pages.contractDevice.deleteConfirm': 'Conferma eliminazione',
  'pages.contractDevice.addTitle': 'Aggiungi dispositivo contrattuale',
  'pages.contractDevice.batchAddTitle': 'Aggiungi in batch',
  'pages.contractDevice.editTitle': 'Modifica dispositivo contrattuale',
  'pages.contractDevice.listTitle': 'Lista dispositivi contrattuali',
  'pages.contractDevice.add': 'Aggiungi',
  'pages.contractDevice.batchAdd': 'Aggiungi in batch',
  'pages.contractDevice.selectCsvTip': 'Seleziona un file CSV',
  'pages.contractDevice.uploadSuccess': 'Caricamento riuscito',
  'pages.contractDevice.macRequired': 'Inserisci l\'indirizzo MAC',
  'pages.contractDevice.protocolTypeRequired': 'Seleziona il tipo di protocollo',
  'pages.contractDevice.statusRequired': 'Seleziona lo stato',
  'pages.contractDevice.expireTimeRequired': 'Seleziona la data di scadenza',
};